import { LoadingAnimation } from '@outbound-ai/ursa'
import { apiPaths } from 'configs/apiConfigs'
import { getClaimEntityBagHistory } from 'features/claims/claimsApi'
import { IClaim } from 'features/claims/types'
import { IClaimActivities } from 'features/entities/types'
import { useEffect } from 'react'
import styled from 'styled-components'
import useSWR from 'swr'

import { ClaimDetailsHistoryItem } from './ClaimDetailsHistoryItem'

interface IClaimDetailsHistoryListProps {
  claim: IClaim
}

export const ClaimDetailsHistoryList = ({ claim }: IClaimDetailsHistoryListProps) => {
  let query = [] as any
  query.push(`Limit=1000`)
  query = query.length ? `?${query.join('&')}` : ''
  const {
    data: claimHistoryResponse,
    error: historyError,
    mutate: updateClaimEntityBagHistory,
  } = useSWR(apiPaths.claimActivites(claim.oaiClaimId, query), getClaimEntityBagHistory)
  useEffect(() => {
    updateClaimEntityBagHistory()
  }, [JSON.stringify(claim)])

  const hasError = !!historyError
  const hasData = !!claimHistoryResponse
  const isLoading = !hasError && !hasData
  if (isLoading) {
    return (
      <>
        <LoadingContainer>
          <span className="loader-content">
            <LoadingAnimation /> Loading History details..
          </span>
        </LoadingContainer>
      </>
    )
  }
  if (hasError) {
    return <>Error</>
  }

  return (
    <Div className="history-inside-container" crows={claimHistoryResponse!.data.length.toString()}>
      {claimHistoryResponse!.data.map((claimActivites: IClaimActivities, index: number) => (
        <ClaimDetailsHistoryItem claimActivites={claimActivites} key={claimActivites.claimActivityId} index={index} />
      ))}
    </Div>
  )
}

interface IHistoryListProps {
  crows: string
}
const Div = styled.div.attrs((props: IHistoryListProps) => ({ 'data-rows': props.crows }))<IHistoryListProps>`
  display: block;
  grid-template: repeat(${(props) => Number(props.crows)}, auto) / auto auto;
  overflow-wrap: anywhere;
  height: 19rem;
  overflow: auto;
`
const LoadingContainer = styled.div`
  .loader-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.grey.darker};
    ${({ theme }) => theme.typography.m.normal};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    margin-top: 50%;
  }
`
